import { CommonModule, DecimalPipe } from "@angular/common";
import { Component, ElementRef, model, input, output, signal, viewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: 'comma-separated-input',
  templateUrl: 'comma-separated-input.component.html',
  styleUrl: 'comma-separated-input.component.less',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, MatTooltipModule, DecimalPipe]
})
export class CommaSeparatedInputComponent {
  // Use model() for proper two-way binding with parent
  public amount = model<number | null>(null);

  public deletable = input<boolean>(false);
  public isDarkLabel = input<boolean>(false);
  public deleteInstance = output<boolean>();
  public isDeleteDisabled = input<boolean>();
  public label = input<string>();
  public controlName = input<string>();
  public isDisabled = input<boolean>();
  public rightJustify = input<boolean>();
  
  public amountInput = viewChild<ElementRef<HTMLInputElement>>("amountInput");

  // Signal to track editing state
  protected isEditing = signal(false);
  // Plain string property for ngModel (no signal needed!)
  protected amountText = "";

  protected onFocus() {
    const current = this.amount();
    this.amountText = current === null || current === undefined ? "" : String(current);
    this.isEditing.set(true);
    
    // Focus the input after Angular renders it
    setTimeout(() => {
      this.amountInput()?.nativeElement.focus();
    }, 0);
  }

  protected onFocusOut() {
    const parsedValue = this.amountText.trim() === "" ? null : Number(this.amountText);

    if (!Number.isNaN(parsedValue)) {
      this.amount.set(parsedValue);
      this.isEditing.set(false);
    }
  }

  protected delete() {
    this.deleteInstance.emit(true);
  }
}
